module.exports = __webpack_public_path__ + "img/trainUavLine.ecd5933c.png";